{
  "version": 1,
  "asset_id": "2b6114d5-84d0-4750-8f1c-c082aca8438d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2b6114d5-84d0-4750-8f1c-c082aca8438d/sleeve-endoscopy-check-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2b6114d5-84d0-4750-8f1c-c082aca8438d/sleeve-endoscopy-check-es-480.webp",
  "original_filename": "sleeve-endoscopy-check-es-480.webp",
  "size": 18974,
  "content_type": "image/webp",
  "created_at": "2026-10-05T00:21:42Z"
}
